import { cn } from "@/lib/utils";

export const Label = ({ as: Tag = "span", className, children, ...rest }) => (
  <Tag className={cn("text-[0.6875rem] font-medium uppercase tracking-[0.08em] text-os-ink-4", className)} {...rest}>
    {children}
  </Tag>
);

export const MonoMeta = ({ as: Tag = "span", className, children, ...rest }) => (
  <Tag className={cn("font-mono text-[0.6875rem] leading-none text-os-ink-3", className)} {...rest}>
    {children}
  </Tag>
);
